import { useRef, useState , useEffect } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";

import back from "../../back.png";
import MsgNew from "./MsgNew";
import MediaLink from "../../helpers/MediaLink";
 


function ZoomR(props)
{

    const [row,setRow] = useState(props.row) ;

    const onBack = (e) => {
        props.goBack();
    }


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );



    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
}



    const setReaded = ()  => {

 
        props.mainView.setProgress(-2);

        var req = {
            id: row.id
        };


    
        fetch( Config.master + '/rest_v1_msg,received_ok', {  //bo pliki sa wyslane do mastera..
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {                                                  
                        } 

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });



    }

    if(row.odczytana == 0)
    {
        setRow({...row, ["odczytana"]:1  });
        setReaded();
    }


    if(view.v == 'new')
    {
        var recv = new Array();

        recv.push({
            px_group_id: row.nadawca.id,
            p_dziecko_id: -1,
            nazwa: row.nadawca.nazwa,            
        });

        return <MsgNew  userData={props.userData}  mainView={props.mainView} recv={recv}  recv_title={ "Re: " + row.tytul} goBack={onBack}  onSukcess={onBack}    />  
    }


    return <div className="view_content">

                
                <h1><PlTitle userData={props.userData} /> / Wiadomości odebrane / {row.tytul}</h1>


                <div className="bg_center">
                    
                        <div className="x_review">
                                  <div className="x_row">
                                               <b>Od:</b> {row.nadawca.nazwa}
                                  </div>

                                  <div className="x_row">
                                        <b> Do:</b>  {row.odbiorca.nazwa}
                                  </div>

                                  <div className="x_row">
                                        {row.czas}
                                  </div>

                                  <div className="x_row_white">                                            
                                           
                                               <div dangerouslySetInnerHTML={{__html: row.tresc}} />
                                  </div>

                                    {
                                        row.zalczniki.length > 0 &&
                                        <div className="x_row">
                                                <b> Załączniki:</b>  
                                                {
                                                      row.zalczniki.map( (z, zi)  => {
                                                        return <MediaLink userData={props.userData} mainView={props.mainView} title={z.nazwa} link={ Config.url + "/api,image,secure," + z.api_unique} />                                                       
                                                    } )
                                                }
                                        </div>
                                    }

                        </div>
                        <br/>
                        <br/>
                        <div className="zoom_btn">
                            <div className="btn" onClick={changeView} v="new" id="-1"  > Udziel odpowiedzi</div>
                    
                            <div className="btn btn_back" onClick={onBack} v="back" id="-1"> Wstecz</div>
                        </div>                

                </div>

                 
                

                

    </div>
}



export default ZoomR;